import * as React from "react";
import styled from "styled-components";
import Gettext from "./common/Gettext";
import Button from "./Buttons/FlatButton";
import withCrashLog from "./common/crashLog";

const ErrorWrapper = styled.div`
  margin: 20px auto;
  text-align: center;
  max-width: 800px;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: center;
`;

const ButtonContainer = styled.div`
  margin: 0 5px;
`;

const ErrorText = styled.div`
  margin-bottom: 10px;
`;

const ErrorMessage = styled.div`
  padding: 20px 0;
`;

const ErrorMessageName = styled.div`
  margin-bottom: 10px;
  font-weight: 700;
  text-align: left;
`;

const ErrorMessageText = styled.div`
  text-align: left;
  margin-bottom: 10px;
`;

const ErrorMessageStack = styled.pre`
  text-align: left;
  font-size: 12px;
  line-height: 1.2;
  font-family: monospace;
  background-color: #eee;
  padding: 10px;
`;

const withErrorCatch = Component => {
  class ErrorBoundary extends React.Component {
    state = {
      error: null,
      info: null,
      showError: false
    };

    componentDidCatch(error, info) {
      this.setState({
        error,
        info
      });

      this.props.crashLog({
        error: {
          message: `${error.name} ${error.message}`,
          info: {
            url: document.location.href,
            stack: error.stack
          }
        }
      });
    }

    toggleShow = () => {
      this.setState(prevState => ({
        showError: !prevState.showError
      }));
    };

    render() {
      if (this.state.error) {
        return (
          <ErrorWrapper>
            <ErrorText>
              <Gettext>We're sorry, an error has occurred.</Gettext>
            </ErrorText>
            <Buttons>
              <ButtonContainer>
                <Button onClick={this.toggleShow}>
                  <Gettext>More</Gettext>
                </Button>
              </ButtonContainer>
              <ButtonContainer>
                <Button
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  <Gettext>Refresh</Gettext>
                </Button>
              </ButtonContainer>
            </Buttons>
            {this.state.showError && (
              <ErrorMessage>
                <ErrorMessageName>{this.state.error.name}</ErrorMessageName>
                <ErrorMessageText>{this.state.error.message}</ErrorMessageText>
                <ErrorMessageStack>{this.state.error.stack}</ErrorMessageStack>
              </ErrorMessage>
            )}
          </ErrorWrapper>
        );
      }

      return <Component {...this.props} />;
    }
  }

  return withCrashLog(props => <ErrorBoundary {...props} />);
};

export default withErrorCatch;



// WEBPACK FOOTER //
// ./src/components/withErrorCatch.js